<template>
  <a-descriptions
    :title="title"
    :column="column"
    :bordered="bordered"
    :size="size"
  >
    <!-- 自定义Description的title -->
    <template slot="title">
      <slot name="title"></slot>
    </template>

    <a-descriptions-item
      v-for="item in infoList"
      :key="item.label"
      :span="item.span || 1"
    >
      <!-- label -->
      <template slot="label" v-if="item.label !== '已生效限额'">
        {{ item.label }}
        <!-- 带说明浮框 -->
        <a-tooltip v-if="item.showTooltip">
          <template slot="title">
            {{ item.tooltip }}
          </template>
          <a-icon :type="item.tooltipIcon || 'question-circle'" />
        </a-tooltip>
      </template>
      <template slot="label" v-else>
        <slot name="cosnameSlot"></slot>
      </template>
      <!-- 自定义slot -->
      <template v-if="item.slotName">
        <slot :name="item.slotName" v-bind:item="item"></slot>
      </template>
      <!-- 过滤，slot优先 -->
      <template v-else-if="item.filter">
        {{ item.value | filter(item.filter) }}
      </template>
      <template v-else>{{ item.value || item.defaultValue || '' }}</template>
    </a-descriptions-item>
    <template>
      <slot name="norvalidAmount"></slot>
    </template>
    <!-- 默认slot -->
    <slot></slot>
  </a-descriptions>
</template>

<script>
import numeral from 'numeral'
export default {
  name: 'CardView',
  props: {
    schema: {
      type: Object,
      // required: true,
      default: function() {
        return {}
      },
    },
    sourceData: {
      type: Object,
      // required: true,
      default: function() {
        return {}
      },
    },
    title: {
      // 类型：string | VNode | v-slot:title
      type: [String, Object],
    },
    // 是否展示边框
    bordered: {
      type: Boolean,
      default: false,
    },
    // 一行的 DescriptionItems 数量，可以写成像素值或支持响应式的对象写法 { xs: 8, sm: 16, md: 24}
    column: {
      type: [Number, Object],
      default: 3,
    },
    // 设置列表的大小。可以设置为 middle 、small, 或不填（只有设置 bordered={true} 生效）
    size: {
      type: String,
      default: 'default',
      validator: function(value) {
        // 这个值必须匹配下列字符串中的一个
        const checkStatus = ['default', 'middle', 'small'].indexOf(value) !== -1
        if (!checkStatus) {
          console.error('size必须为 default| middle | small中的一个')
        }
        return checkStatus
      },
    },
  },
  computed: {
    infoList() {
      return this.schema2ListBySourceData(this.sourceData, this.schema)
    },
    validLimitAmountList() {
      return this.schema2ListBySourceData(this.sourceData, this.schema)
    },
  },
  filters: {
    filter(value, filter) {
      // filter对象
      const FILTER_OBJ = {
        formatAmount: function(num) {
          return numeral(num).format('0,0.00')
        },
        riskTypeFilter: function(num) {
          if (!num && num !== 0) return ''
          const riskTypeMap = new Map([
            [1, '一般审批'],
            [2, '高风险审批'],
          ])
          return riskTypeMap.get(Number(num)) || ''
        },
      }
      if (typeof filter === 'string' && FILTER_OBJ[filter]) {
        return FILTER_OBJ[filter](value)
      }
      if (typeof filter === 'function') {
        return filter(value)
      }
      return value
    },
  },

  methods: {
    schema2ListBySourceData(sourceData, SCHEMA) {
      if (!sourceData || !SCHEMA) {
        return []
      }
      const keys = Object.keys(SCHEMA)
      let list = []
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (sourceData[key] != undefined) {
          // 在sourceData中有key对应值才放入list
          SCHEMA[key].value = sourceData[key]
          SCHEMA[key].key = key
          list.push(SCHEMA[key])
        }
      }
      return list
    },
  },
}
</script>

<style></style>
